import "../css/style.scss"

import MobileMenu from "./modules/MobileMenu"
import Search from "./modules/Search"
import Notes from "./modules/Notes"

const mobileMenu = new MobileMenu()
const search = new Search()
const notes = new Notes()